import ArrowRight from "@/assets/Icons/arrowRight";
import { Button } from "@/components/ui/button";
import Image from "next/image";
import React from "react";
import Skm from "@/assets/Images/skm.png";
import Link from "next/link";

const SkmSection = () => {
  return (
    <div className="bg-[#DDE6D5] py-14">
      <div className="container mx-auto flex md:flex-row flex-col items-center gap-4">
        <div className="h-[220px] md:h-[320px] flex-shrink-0">
          <Image
            alt="icon"
            height={600}
            width={600}
            src={Skm}
            className="h-full object-contain w-fit"
          />
        </div>
        <div className="flex flex-col gap-10 ">
          <div className="text-3xl md:text-4xl font-semibold">
            Survei & Pengaduan
          </div>
          <div className="text-[#70707B] text-justify text-base md:text-lg">
            Kami percaya bahwa layanan publik yang baik lahir dari partisipasi
            aktif masyarakat. Melalui fitur survei dan pengaduan ini, Anda dapat
            menyampaikan penilaian terhadap kualitas layanan Dinas Pertanian
            serta melaporkan kendala, masukan, atau kebutuhan yang Anda alami di
            lapangan.
          </div>
          <div className="flex md:flex-row flex-col gap-5 items-center">
            <Link href="/skm/survey">
              <Button className="px-5 w-full md:w-fit flex items-center gap-2 text-base shadow-md bg-primary text-white rounded-full">
                Isi Survey Kepuasan Masyarakat
                <ArrowRight />
              </Button>
            </Link>
            <Link href="/skm/complaint">
              <Button className="px-5 w-full md:w-fit flex items-center gap-2  text-base shadow-md border text-primary bg-white hover:bg-slate-50 rounded-full">
                Buat Pengaduan
                <ArrowRight />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkmSection;
